<main>
  <div class="user-form">
    <h1 class="h3 mb-3 font-weight-normal">Your account has been deactivated.</h1>
    <p>Your account will be deleted within the next 7 days by an admin.</p>
    <a class="btn btn-lg btn-primary btn-block" routerLink="/home" role="button">Back to landing page</a>
  </div>
</main>

